import {Component, ChangeDetectionStrategy} from "@angular/core";
import {PerformaInfoService} from "src/app/services/performa-info.service";

@Component({
    selector: "app-error-404",
    templateUrl: "./error404.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class Error404Component {
    constructor(public readonly infoService: PerformaInfoService) {}
}
